<template>
  <div class="p-mypage__shipping p-mypage__shipping--edit mypage-bloc">
    <div class="mypage-bloc__head">
      <h2 v-if="addressStore.isAddressEdit">{{ $t('TEXT_UPDATE_ADDRESS') }}</h2>
      <h2 v-else>{{ $t('TEXT_ADD_ADDRESS') }}</h2>
      <!-- <h2>配送先の確認・変更</h2> -->
    </div>
    <div class="mypage-bloc__content">

      <!-- shipping form -->
      <div class="shipping__form">
        <h3>{{ $t('TEXT_REQUIRED_FIELDS') }}</h3>
        <p><span>＊</span>{{ $t('TEXT_REQUIRED_FIELD') }}</p>

      <div class="p-shipping__information">
          <dl>
              <dt><span class="icon"><img src="@/assets/img/ui_parts/svg/attention_icon_contact.svg" alt="！" /></span>{{
                  $t('LABEL_PLEASE_CONFIRM') }}</dt>
              <dd>{{ $t('TEXT_SHIPPING_ADDRESS_NOTICE') }}</dd>
          </dl>
      </div>
        <!-- <form> -->
        <div class="p-shipping-edit__form c-form-parts">
          <dl class="name">
            <dt>{{ $t('LABEL_NAME') }}<span>＊</span></dt>
            <dd>
              <ul class="input-area" :class="{ 'is-error': v$.last_name.$error || v$.first_name.$error || addressStore.addressFormErrors.last_name || addressStore.addressFormErrors.first_name }">
                <!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                <li><input type="text" name="last_name" id="last_name" class="plchldr" v-model="addressStore.addressForm.last_name" :placeholder="$t('LABEL_LAST_NAME')" value="" required></li>
                <li><input type="text" name="first_name" id="first_name" class="plchldr" v-model="addressStore.addressForm.first_name" :placeholder="$t('LABEL_FIRST_NAME')" value="" required></li>
              </ul>
              <p class="error-txt" v-if="v$.last_name.$error">{{ $t(v$.last_name.$errors[0].$message) }}</p>
              <p class="error-txt" v-if="v$.first_name.$error">{{ $t(v$.first_name.$errors[0].$message) }}</p>
              <p class="error-txt" v-if="addressStore.addressFormErrors.last_name">{{ addressStore.addressFormErrors.last_name }}</p>
              <p class="error-txt" v-if="addressStore.addressFormErrors.first_name">{{ addressStore.addressFormErrors.first_name }}</p>
            </dd>
          </dl>

          <dl class="kana">
            <dt>{{$t('LABEL_NAME_KANA')}}<span>＊</span></dt>
            <dd>
              <ul class="input-area" :class="{ 'is-error': v$.last_name_kana.$error || v$.first_name_kana.$error || addressStore.addressFormErrors.last_name_kana || addressStore.addressFormErrors.first_name_kana }"><!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                <li><input type="text" name="last_name_kana" id="last_name_kana" class="plchldr" v-model="addressStore.addressForm.last_name_kana" :placeholder="$t('LABEL_LAST_NAME_KANA')" value="" required></li>
                <li><input type="text" name="first_name_kana" id="first_name_kana" class="plchldr" v-model="addressStore.addressForm.first_name_kana" :placeholder="$t('LABEL_FIRST_NAME_KANA')" value="" required></li>
              </ul>
              <p class="error-txt" v-if="v$.last_name_kana.$error">{{ $t(v$.last_name_kana.$errors[0].$message) }}</p>
              <p class="error-txt" v-if="v$.first_name_kana.$error">{{ $t(v$.first_name_kana.$errors[0].$message) }}</p>
              <p class="error-txt" v-if="addressStore.addressFormErrors.last_name_kana">{{ addressStore.addressFormErrors.last_name_kana }}</p>
              <p class="error-txt" v-if="addressStore.addressFormErrors.first_name_kana">{{ addressStore.addressFormErrors.first_name_kana }}</p>
            </dd>
          </dl>

          <dl class="telephone">
            <dt>{{ $t('LABEL_PHONE_NUMBER') }}<span>＊</span></dt>
            <dd>
              <div class="input-area" :class="{ 'is-error': v$.tel.$error || addressStore.addressFormErrors.tel }">
                <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                <input type="tel" name="tel" id="tel" class="plchldr" v-model="addressStore.addressForm.tel" placeholder="0300000000" value="" required>
              </div>
              <p class="sub-txt">{{ $t('LABEL_NO_HYPHEN') }}</p>
              <p class="error-txt" v-if="v$.tel.$error">{{ $t(v$.tel.$errors[0].$message) }}</p>
              <p class="error-txt" v-if="addressStore.addressFormErrors.tel">{{ addressStore.addressFormErrors.tel }}</p>
            </dd>
          </dl>

          <dl class="zipcode">
            <dt>{{ $t('LABEL_ZIP_CODE') }}<span>＊</span></dt>
            <dd>
              <div class="input-area" :class="{ 'is-error': v$.zip_code.$error || addressStore.addressFormErrors.zip_code }">
                <!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                <input type="tel" name="zip_code" id="zipcode" maxlength="7" class="plchldr" v-model="addressStore.addressForm.zip_code" placeholder="0000000" @keyup="zipCodeChangeInEdit(addressStore.addressForm.zip_code)">
              </div>
              <p class="sub-txt">{{ $t('LABEL_NO_HYPHEN') }}</p>
              <p class="error-txt" v-if="v$.zip_code.$error">{{ $t(v$.zip_code.$errors[0].$message) }}</p>
              <p class="error-txt" v-if="addressStore.addressFormErrors.zip_code">{{ addressStore.addressFormErrors.zip_code }}</p>
            </dd>
          </dl>

          <dl class="prefecture">
            <dt>{{ $t('LABEL_ADDRESS_1') }}<span>＊</span></dt>
            <dd>
              <div class="select-area" :class="{ 'is-error': v$.address_1.$error || addressStore.addressFormErrors.address_1 }">
                <!-- TODO: When there is an error, add "is-error" class to this "ul.select-area" -->
                <span class="select-box">
                  <select name="address_1" id="address_1" v-model="addressStore.addressForm.address_1" required>
                    <option :value="i" v-for="(v, i) in PREFECTURES_JA">{{ v }}</option>
                  </select>
                </span>
              </div>
              <p class="error-txt">{{ $t('LABEL_SELECT_PREFECTURE') }}</p>
            </dd>
          </dl>

          <dl class="municipalities">
            <dt>{{ $t('LABEL_ADDRESS_2') }}<span>＊</span></dt>
            <dd>
              <div class="input-area" :class="{ 'is-error': v$.address_2.$error || addressStore.addressFormErrors.address_2 }">
                <!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                <input type="text" name="address_2" id="address_2" class="plchldr" v-model="addressStore.addressForm.address_2" :placeholder="$t('LABEL_ADDRESS_2')" required>
              </div>
              <p class="error-txt" v-if="v$.address_2.$error">{{ $t(v$.address_2.$errors[0].$message) }}</p>
              <p class="error-txt" v-if="addressStore.addressFormErrors.address_2">{{ addressStore.addressFormErrors.address_2 }}</p>
            </dd>
          </dl>

          <dl class="block-number">
            <dt>{{ $t('LABEL_ADDRESS_3_4') }}<span>＊</span></dt>
            <dd>
              <div class="input-area" :class="{ 'is-error': v$.address_3.$error || addressStore.addressFormErrors.address_3 }">
                <!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                <input type="text" name="address_3" id="address_3" class="plchldr" v-model="addressStore.addressForm.address_3" :placeholder="$t('LABEL_ADDRESS_3_4')" required>
              </div>
              <p class="error-txt" v-if="v$.address_3.$error">{{ $t(v$.address_3.$errors[0].$message) }}</p>
              <p class="error-txt" v-if="addressStore.addressFormErrors.address_3">{{ addressStore.addressFormErrors.address_3 }}</p>
            </dd>
          </dl>
        </div>

        <div class="p-shipping-edit__btn">
          <div v-if="addressStore.isAddressEdit" class="c-btn c-btn--shptedit-submit"><input type="button" @click="updateAddress()" :value="$t('LABEL_UPDATE_BUTTON')"></div>
          <div v-else class="c-btn c-btn--shptedit-submit"><input type="button" @click="registerAddress()" :value="$t('LABEL_REGISTER_BUTTON')"></div>
          <div class="c-btn c-btn--shptedit-cancel">
            <button @click="resetAddressForm()">{{ $t('LABEL_CANCEL') }}</button>
          </div>
        </div>
        <!-- </form> -->

        <!-- TODO: .is-loading -->
        <div class="c-loader p-shptedit-edit__loading"><span class="c-loader__icon"></span></div>
      </div>

    </div>
  </div>
</template>

<script setup>

import {useShippingAddressStore} from "@/stores/ShippingAddressStore";
import {useVuelidate} from "@vuelidate/core";
import {getAddressRegisterRule} from "@/validations/ShippingAddressValidation";
import {PREFECTURES_JA} from "@/data/constants";
import * as addressUtility from "@/helpers/addressUtility";
import { useI18n } from 'vue-i18n';

const addressStore = useShippingAddressStore();
const { t } = useI18n();
const v$ = useVuelidate(getAddressRegisterRule(t), addressStore.addressForm);

async function registerAddress() {
    if (!await v$.value.$validate()) {
        return false;
    }

    if (await addressStore.registerAddress()) {
        hideAddresses();
    }
}

async function updateAddress() {
    if (!await v$.value.$validate()) {
        return false;
    }

    if (await addressStore.updateAddress()) {
        resetAddressForm();
        hideAddresses();
    }
}

function zipCodeChangeInEdit() {
    if (addressStore.addressForm.zip_code !== null) {
        addressUtility.zipCodeAutoComplete(addressStore.addressForm, addressStore.addressForm.zip_code.toString());
    }
}

function resetAddressForm() {
    v$.value.$reset();
    addressStore.resetAddressForm();
}

function hideAddresses() {
    $('.p-mypage__shipping--list').css('display', 'none').fadeIn(400);
    $('.p-mypage__shipping--edit').removeAttr('style');
    $('html, body').animate({ scrollTop: 0 }, 300);
}

</script>